import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registrationForm: {},
  renewalForm: {},
};

const userFormSlice = createSlice({
  name: "userForm",
  initialState,
  reducers: {
    saveRegistrationForm: (state, action) => {
      state.registrationForm = { ...state.registrationForm, ...action.payload };
    },
    saveRenewalForm: (state, action) => {
      state.renewalForm = { ...state.renewalForm, ...action.payload };
    },
    clearRegistrationForm: (state) => {
      state.registrationForm = {};
    },
    clearRenewalForm: (state) => {
      state.renewalForm = {};
    },
  },
});

export const {
  saveRegistrationForm,
  saveRenewalForm,
  clearRegistrationForm,
  clearRenewalForm,
} = userFormSlice.actions;

export default userFormSlice.reducer;
